import * as React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type ContainerSize = 'form-single' | 'form-two' | 'detail' | 'prose' | 'auth';

type PageContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: ContainerSize;
};

const sizeMap: Record<ContainerSize, string> = {
  'form-single': 'max-w-[920px]',
  'form-two': '',
  detail: '',
  prose: 'max-w-[680px]',
  auth: 'max-w-[460px]',
};

export const PageContainer = React.forwardRef<HTMLDivElement, PageContainerProps>(
  ({ className, size = 'detail', children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('w-full mx-auto', sizeMap[size], className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);
PageContainer.displayName = 'PageContainer';
